// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loader_overlay__eMvxB","loader":"Loader_loader__1j2Bs","paging":"Loader_paging__25Ms-","text":"Loader_text__KbJGA"};